export const adminEventAddons = (params: { eventId: number }) => `event:${params.eventId}`;
